// import ViewStack from '../core/view-manager/view-stack'
// import ViewFactory from '../core/view-manager/view-factory'
// import NavigationController from '../core/view-manager/navigation-controller'
// import NavigationAPI from '../core/view-manager/navigation-api'
// import ContentLoader from '../core/view-manager/content-loader'
// import HistoryController from '../core/view-manager/history-controller'
import StackController from '../core/view-manager/stack-controller'
import NavigationAdapter from '../core/view-manager/navigation-adapter'
import ContentLoader from '../core/view-manager/content-loader'
import personView from '../core/view-manager/views/person-view'
import projectView from '../core/view-manager/views/project-view'
import simpleView from '../core/view-manager/views/simple-view'
import formView from '../core/view-manager/views/form-view'
import formContactView from '../core/view-manager/views/form-contact-view'
import formUploadView from '../core/view-manager/views/form-upload-view'
import formDownloadView from '../core/view-manager/views/form-download-view'

const VIEW_REGISTRY = [['form-download', formDownloadView]]

const HASH_TO_VIEW = {
	'#download-bim': 'form-download',
}

const getHashViewMap = (root = document) => {
	const templates = Array.from(root.querySelectorAll('.js-views-manager template[data-view-hash][data-view-type][data-view-id]'))
	return templates.reduce((acc, tpl) => {
		const hash = `#${tpl.dataset.viewHash.trim()}`
		acc[hash] = {
			type: tpl.dataset.viewType.trim(),
			viewId: tpl.dataset.viewId.trim(),
		}
		return acc
	}, {})
}
const bindHashRouting = (viewManager, swup, hashMap) => {
	const handleHash = () => {
		const target = hashMap[window.location.hash]

		if (!target) {
			if (viewManager.stack?.length) viewManager.closeTop({ fromPop: true })
			return
		}

		const top = viewManager.stack?.[viewManager.stack.length - 1]
		if (top?.view?.type === target.type && top?.view?.data?.viewId === target.viewId) return

		viewManager.open({
			type: target.type,
			viewId: target.viewId,
			url: null,
			static: true,
			suppressHistory: true,
			historyUrl: window.location.hash,
			data: { viewId: target.viewId },
		})
	}

	document.addEventListener(
		'click',
		(e) => {
			const link = e.target.closest('a[href^="#"]')
			if (!link) return
			const href = link.getAttribute('href')

			if (!hashMap[href]) return
			e.preventDefault()
			e.stopPropagation()
			if (window.location.hash !== href) window.location.hash = href
			else handleHash()
		},
		true,
	)

	window.addEventListener('hashchange', handleHash)
	if (swup?.hooks?.on) swup.hooks.on('link:anchor', handleHash)
	handleHash()
}
export const initViewManager = (ctx) => {
	const adapter = new NavigationAdapter({ swup: ctx.swup })
	const contentLoader = new ContentLoader({ swup: ctx.swup })

	const viewManager = new StackController({
		rootSelector: '.js-views-manager',
		adapter,
		contentLoader,
		lenis: ctx.lenis || null,
		services: {
			componentsManager: ctx.componentsManager,
			browser: ctx.browser,
		},
	})

	// VIEW_REGISTRY.forEach(([type, view]) => viewManager.register(type, view))

	viewManager.register('form-download', formDownloadView)

	const hashMap = getHashViewMap(document)

	bindHashRouting(viewManager, ctx.swup, hashMap)

	document.addEventListener('view:close', () => viewManager.closeTop())

	viewManager.mount()

	ctx.viewManager = viewManager
	return viewManager
	// const adapter = new NavigationAdapter({ swup: ctx.swup })
	// const contentLoader = new ContentLoader({ swup: ctx.swup })

	// const viewManager = new StackController({
	// 	rootSelector: '.js-views-manager',
	// 	adapter,
	// 	contentLoader,
	// 	lenis: false,
	// 	services: {
	// 		componentsManager: ctx.componentsManager,
	// 	},
	// })

	// // viewManager.register('person', personView)
	// // viewManager.register('project', projectView)
	// viewManager.register('simple', simpleView)
	// viewManager.register('form-contact', formContactView)
	// viewManager.register('form-upload', formUploadView)

	// const hashToView = {
	// 	'#upload-cv': 'form-upload',
	// 	'#contact': 'form-contact',
	// }

	// const handleHash = () => {
	// 	const type = hashToView[window.location.hash]
	// 	if (!type) return
	// 	const top = viewManager.stack?.[viewManager.stack.length - 1]
	// 	if (top?.view?.type === type) return
	// 	viewManager.open({ type, url: null, static: true })
	// }

	// window.addEventListener('hashchange', handleHash)
	// handleHash()

	// // close handling
	// document.addEventListener('view:close', () => {
	// 	viewManager.closeTop()
	// })

	// console.log('Mounting View Manager')
	// viewManager.mount()

	// ctx.viewManager = viewManager
	// console.log('Initializing View Manager')

	// return viewManager
}
